import { render, staticRenderFns } from "./refus-total.vue?vue&type=template&id=3b23ea98"
import script from "./refus-total.vue?vue&type=script&lang=ts"
export * from "./refus-total.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports